import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import _ from 'lodash';
import type { useGetObligationList } from 'src/hooks/queries/obligation/useGetObligationList';

import { getFriendlyId } from '@/utils/friendlyId';

type GetObligationListData = NonNullable<
  ReturnType<typeof useGetObligationList>['data']
>;

export const getOptions = (
  allObligations: GetObligationListData | undefined,
  defaultValues: { value: string }[],
  excludedIds?: string[]
): { value: string; label: string }[] => {
  const ids = defaultValues.map((d) => d.value);
  const obligationsById = _.keyBy(allObligations?.obligation, 'Id');

  let options: {
    Id: string;
    Title?: string;
    SequentialId?: null | number | undefined;
  }[] = allObligations?.obligation ?? [];

  options = options.concat(
    (allObligations?.node ?? []).filter(
      (n) => ids.includes(n.Id) && !obligationsById[n.Id]
    )
  );

  return (
    options
      ?.filter((o) => !excludedIds?.includes(o.Id))
      .map((o) => ({
        value: o.Id,
        label:
          o?.Title ??
          getFriendlyId(Parent_Type_Enum.Obligation, o.SequentialId),
      })) ?? []
  );
};
